import classNames from 'classnames'

import { SonaDarkIcon, SonaLightIcon } from '@ui/icons/sona'
import { useTheme } from '@ui/theme'

import * as styles from './AiAgentIcon.css'

interface AiAgentIconProps {
  className?: string
}

export default function AiAgentIcon({ className }: AiAgentIconProps) {
  const { themeKey } = useTheme()
  const Icon = themeKey === 'dark' ? SonaDarkIcon : SonaLightIcon
  return <Icon aria-hidden className={classNames(styles.icon, className)} />
}
